import React, { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Button, Space, Modal } from 'antd';
import { apiRequest } from '../../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../../components/errorHandler';

interface CityModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;
  initialValues?: {
    city_id?: number;
    city_name?: string;
  } | null;
  isEditMode?: boolean;
}

const CityModal: React.FC<CityModalProps> = ({
  visible,
  onCancel,
  onCreate,
  initialValues = null,
  isEditMode = false,
}) => {
  const [form] = Form.useForm();
  const [isModalClose, setIsModalClose] = useState(true);

  const isSubmitDisabled = () => {
    const errors = form.getFieldsError();
    return errors.some(({ errors }) => errors.length > 0);
  };

  const handleAddCity = async (values: any) => {
    try {
      const dataVal = {
        city_name: values.city_name,
        ...(initialValues?.city_id && { city_id: initialValues.city_id }),
      };

      const url = isEditMode ? 'edit-city' : 'add-city';
      const method = isEditMode ? 'put' : 'post';

      const data = await apiRequest({
        method,
        url,
        data: dataVal,
      });

      onCreate(data);
      showSuccess(isEditMode ? 'City updated successfully!' : 'City created successfully!');
      form.resetFields();
      if (isModalClose) onCancel();
    } catch {
      showError(`Failed to ${isEditMode ? 'update' : 'create'} city`);
    }
  };

  useEffect(() => {
    if (visible && isEditMode && initialValues) {
      form.setFieldsValue({ city_name: initialValues.city_name });
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, isEditMode, initialValues, form]);

  return (
    <Modal
      title={isEditMode ? 'Edit City' : 'Add New City'}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="50%"
      destroyOnHidden
    >
      <Form form={form} layout="vertical" onFinish={handleAddCity} autoComplete="off">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="city_name"
              label={
                <span>
                  City&nbsp;
                  <span style={{ fontSize: '12px', color: '#888' }}>
                    (Max 255 characters)
                  </span>
                </span>
              }
              rules={[
                { required: true, message: 'Please enter the City' },
                { max: 255, message: 'Maximum 255 characters allowed' },
              ]}
            >
              <Input showCount maxLength={255} placeholder="e.g., Los Angeles" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            {!isEditMode && (
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setIsModalClose(false)}
                disabled={isSubmitDisabled()}
              >
                Submit & Create New City
              </Button>
            )}
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setIsModalClose(true)}
              disabled={isSubmitDisabled()}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CityModal;
